<template>
  <v-row justify="center">
    <v-dialog
      :key="changeKey"
      v-model="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary d-print-none"
        >
          <v-btn
            icon
            dark
            @click="hideDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <span v-text="subTitle" />
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="hideDialog"
            >
              Close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list
          three-line
          subheader
        >
          <v-list-item>
            <v-list-item-content>
              <slot name="header" />
              <open-enrollment-summary
                :open-enrollment="openEnrollment"
              />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'OpenEnrollmentSummaryDialog',

    components: {
      OpenEnrollmentSummary: () => import('./OpenEnrollmentSummary'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      changeKey: 0,
    }),

    computed: {
      subTitle () {
        return this.openEnrollment ? this.openEnrollment.broker + ' / ' + this.openEnrollment.groupName + ' / ' + this.openEnrollment.brokerGroupYear : 'None'
      },

      show: {
        get () {
          return this.openEnrollment !== null
        },
        set (value) {
          if (!value) {
            this.openEnrollment = null
          }
        },
      },
    },

    watch: {
      openEnrollment (val) {
        this.changeKey++
      },
    },

    methods: {
      hideDialog () {
        this.$emit('hide')
      },
    },
  }
</script>
